<template>
  <div class="mbo-scene mbo-intro">
    <div class="mbo-intro__plate">
      <div v-if="title" class="mbo-intro__title">
        <MbFitText :text="title" :max="96" :min="40"/>
      </div>
      <div class="mbo-intro__sub">{{ subtitle }}</div>

      <div v-if="battle" class="mbo-intro__vs">
        <div v-for="side in sides" :key="side.camp" :class="['mbo-intro__team', 'is-camp' + side.camp]">
          <span class="mbo-intro__logo">
            <img v-if="side.logo" :src="side.logo" alt="">
            <span v-else>{{ side.short }}</span>
          </span>
          <span class="mbo-intro__name"><MbFitText :text="side.name" :max="56" :min="24"/></span>
          <span v-if="hasSeries" class="mbo-intro__wins">{{ side.wins }}</span>
        </div>
        <em class="mbo-intro__versus">VS</em>
      </div>
    </div>
  </div>
</template>

<script>
import MbFitText from '@/components/MlbbBroadcast/overlay/MbFitText.vue'
import {campByNumber, campLogoUrl, campShortName, campTeamName, seriesScore} from '@/common/mlbbBroadcast'
import {gameNumber} from '@/common/mlbbOverlay'

// Макета заставки нет — временная вёрстка в стиле ингейма, пока дизайнер не пришлёт свою
export default {
  name: 'MbSceneIntro',
  components: {MbFitText},
  props: {
    battle: {type: Object, default: null},
    series: {type: Array, default: () => []},
    title: {type: String, default: ''},
  },
  computed: {
    hasSeries() {
      return this.series.length > 1
    },
    subtitle() {
      const n = this.battle ? gameNumber(this.series, this.battle.id) : null
      return n ? `Игра ${n} · скоро начнём` : 'Скоро начнём'
    },
    sides() {
      const score = seriesScore(this.series)
      return [1, 2].map((n) => {
        const camp = campByNumber(this.battle, n) || {camp: n}
        return {
          camp: n,
          name: campTeamName(camp),
          short: campShortName(camp).slice(0, 2),
          logo: campLogoUrl(camp),
          wins: score[camp.group_team_id] || 0,
        }
      })
    },
  },
}
</script>
